'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _campaignActivityModal = require('./campaignActivityModal.html');

var _campaignActivityModal2 = _interopRequireDefault(_campaignActivityModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CampaignDetailController = function () {
    function CampaignDetailController($scope, $state, $stateParams, $ionicLoading, $ionicPopup, ApiCampaigns, ApiContacts, ApiTasks, MessageBox, $filter, $rootScope, filterHistory, $ionicScrollDelegate, $ionicModal, FileSaver, $cordovaToast, sentEmailPopup, ApiUser) {
        var _this = this;

        _classCallCheck(this, CampaignDetailController);

        this.FileSaver = FileSaver;
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$state = $state;
        this.ApiCampaigns = ApiCampaigns;
        this.ApiContacts = ApiContacts;
        this.ApiTasks = ApiTasks;
        this.MessageBox = MessageBox;
        this.activeTab = 'detail';
        this.$filter = $filter;
        this.translateFilter = $filter('translate');
        this.filterHistory = filterHistory;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.$cordovaToast = $cordovaToast;

        this.campaign = null;
        this.campaigns = [];
        this.selections = null;
        this.contacts = null;

        this.campaignId = $stateParams.campaignId;
        this.levelOfInterest = $stateParams.level;
        this.childrenIds = [];
        this.sortOrder = $stateParams.sortOrder || 'contactInfo.contact.lastName'; // sort using contact name by default
        this.sortDirection = false;
        this.loading = []; // track data loading
        this.activityReportData = [];
        this.isActivityReport = false;
        this.sentEmailPopup = sentEmailPopup;

        if (this.levelOfInterest) {
            this.activeTab = 'contacts';
        }

        var self = this;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParam) {
            if (self.closeModal != null) self.closeModal();
        });

        this.activityReportModal = $ionicModal.fromTemplate(_campaignActivityModal2.default, {
            scope: $scope
        });
        ApiUser.getUser().then(function (user) {
            _this.user = user;
        });
    }

    _createClass(CampaignDetailController, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            var self = this;
            self.getCampaign();
            self.getCurrencyList();
            self.resolveTaskPromise();
            self.getAllChildCampaigns();
            self.getCampaignChildren();
            self.getChartData();

            this.ApiCampaigns.getActivityReport(this.campaignId).then(function (data) {
                _this2.isActivityReport = data.length > 0;
            });
        }
    }, {
        key: 'reloadChildren',
        value: function reloadChildren() {
            this.getCampaign();
            this.getCampaignChildren();
        }
    }, {
        key: 'resolveTaskPromise',
        value: function resolveTaskPromise() {
            this.taskParameters = { campaignIds: [this.campaignId] };
            this.updateCampaignIdInSavedFilter();
        }
    }, {
        key: 'updateCampaignIdInSavedFilter',
        value: function updateCampaignIdInSavedFilter() {
            var savedFilter = this.filterHistory.readFilter('campaign-detail');
            if (savedFilter && savedFilter.campaignIds && this.campaignId != savedFilter.campaignIds[0]) {
                savedFilter.campaignIds = [this.campaignId];
                this.filterHistory.saveFilter(savedFilter, 'campaign-detail');
            }
        }
    }, {
        key: 'getCampaign',
        value: function getCampaign() {
            var self = this;
            this.showLoading();
            this.ApiCampaigns.getCampaign(this.campaignId).then(function (campaign) {
                self.campaign = campaign || {};
                self.campaign.hideCheckedItems = true; // hide the checked items in the contacts modal
                if (self.campaign.parent && self.levelOfInterest) {
                    self.activeTab = 'campaigns';
                }
            }).finally(function () {
                self.hideIonicLoading();
            });
        }
    }, {
        key: 'getCampaignChildren',
        value: function getCampaignChildren() {
            var _this3 = this;

            this.showLoading();
            this.ApiCampaigns.getCampaignChildren(this.campaignId).then(function (children) {
                _this3.childCampaigns = children || [];
                _this3.getChildrenIds();
                _this3.hideIonicLoading();
            }, function (error) {
                console.error(error);
            });
        }
    }, {
        key: 'getChildrenIds',
        value: function getChildrenIds() {
            var _this4 = this;

            this.childrenIds = [];
            this.childCampaigns.map(function (c) {
                _this4.childrenIds.push(c.campaignId);
            });
        }
    }, {
        key: 'getAllChildCampaigns',
        value: function getAllChildCampaigns() {
            var _this5 = this;

            this.showLoading();
            this.ApiCampaigns.getAllChildCampaigns().then(function (campaigns) {
                _this5.campaigns = campaigns;
                _this5.hideIonicLoading();
            });
        }
    }, {
        key: 'getCurrencyList',
        value: function getCurrencyList() {
            var _this6 = this;

            this.showLoading();
            this.ApiCampaigns.retrieveCurrencyList().then(function (currencyObjects) {
                _this6.currencies = currencyObjects.data;
                _this6.hideIonicLoading();
            });
        }
    }, {
        key: 'getChartData',
        value: function getChartData() {
            var _this7 = this;

            this.showLoading();
            this.ApiCampaigns.getChartData(this.campaignId).then(function (data) {
                _this7.populateCampaignDetails(data);
                _this7.chartData = data || {};
                _this7.hideIonicLoading();
            });
        }
    }, {
        key: 'populateCampaignDetails',
        value: function populateCampaignDetails(campaign) {
            var _this8 = this;

            var campaigns = [campaign];
            var self = this;
            angular.forEach(campaigns, function (campaign) {
                if (campaign.campaign) {
                    campaign.currency = angular.copy(self.getCurrencySymbol(campaign.campaign.campaignCurrency));
                    campaign.campaign.investmentLabels = [self.translateFilter('MISSING_INVESTMENT'), self.translateFilter('POTENTIAL_INVESTMENT'), self.translateFilter('COMMITED_INVESTMENT')];
                    campaign.campaign.investmentData = [];
                    campaign.campaign.investmentData.push(_this8.calculateMissingInvestment(campaign.campaign));
                    campaign.campaign.investmentData.push(campaign.campaign.promisedInvestment);
                    campaign.campaign.investmentData.push(campaign.campaign.confirmedInvestment);

                    if (campaign.numOfContactsByLevelOfInterest) {
                        campaign.numOfContactsByLevelOfInterest.lOILabels = ['No', 'Selected', 'Pending', 'Low', 'Resubmission Later', 'Decision via Gatekeeper / Parent / Advisor', 'General', 'MP Meeting', 'Strong interest', 'Due Diligence', 'Soft Circled', 'Committed'];
                        campaign.numOfContactsByLevelOfInterest.lOIData = [];
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.NO);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.SELECTED);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.PENDING);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.LOW);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.RESUBMISSION_LATER);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.DECISION_VIA_GATEKEEPER_ADVISOR_PARENT);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.GENERAL);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.MP_MEETING);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.STRONG_INTEREST);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.DUE_DILIGENCE);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.SOFT_CIRCLED);
                        campaign.numOfContactsByLevelOfInterest.lOIData.push(campaign.numOfContactsByLevelOfInterest.COMMITED);
                    }
                }
            });
        }
    }, {
        key: 'calculateMissingInvestment',
        value: function calculateMissingInvestment(campaign) {
            var missingInvestment = campaign.targetInvestment - campaign.promisedInvestment - campaign.confirmedInvestment;
            if (missingInvestment < 0) {
                return 0;
            } else {
                return missingInvestment;
            }
        }
    }, {
        key: 'promptCampaignDelete',
        value: function promptCampaignDelete($event) {
            var _this9 = this;

            $event.preventDefault();
            var dialogResult = this.$ionicPopup.confirm({
                title: this.$filter('translate')('DELETE_CAMPAIGN'),
                template: this.$filter('translate')('DELETE_CAMPAIGN_PROMPT')
            });

            dialogResult.then(function (res) {
                if (res) {
                    _this9.removeCampaign(_this9.campaign);
                }
            });
        }
    }, {
        key: 'removeCampaign',
        value: function removeCampaign(campaign) {
            var _this10 = this;

            this.showLoading();
            var loadParms = { campaignType: 'CAMPAIGN' };
            if (this.campaign.parent) {
                loadParms = { campaignType: 'MOTHER_CAMPAIGN' };
            }
            this.ApiCampaigns.deleteCampaign(campaign.campaignId).then(function (res) {
                _this10.hideIonicLoading();
                if (res === null) {
                    _this10.$state.go('campaigns', loadParms, { reload: true });
                }
            });
        }
    }, {
        key: 'showLoading',
        value: function showLoading() {
            this.loading.push(1);
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
        }
    }, {
        key: 'hideIonicLoading',
        value: function hideIonicLoading() {
            var self = this;
            self.loading.pop();
            if (self.loading.length <= 0) self.$ionicLoading.hide();
        }
    }, {
        key: 'getCurrencySymbol',
        value: function getCurrencySymbol(currencyShortName) {
            if (!this.currencies || !currencyShortName) return '';

            var currency = this.currencies.find(function (currency) {
                return currency.shortName === currencyShortName;
            });

            return currency && currency.symbol;
        }
    }, {
        key: 'redirectToEditPage',
        value: function redirectToEditPage() {
            if (this.campaign) {
                var state = this.campaign.parent ? 'motherCampaignEdit' : 'campaignEdit';
                this.$state.go(state, { campaignId: this.campaign.campaignId });
            }
        }
    }, {
        key: 'onTabChange',
        value: function onTabChange(type) {
            this.activeTab = type;
            this.$ionicScrollDelegate.scrollTop();
        }
    }, {
        key: 'activityReportShow',
        value: function activityReportShow() {
            var _this11 = this;

            this.ApiCampaigns.getActivityReport(this.campaignId).then(function (data) {
                var activityData = [];
                data.forEach(function (value) {
                    var item = activityData.find(function (item) {
                        return item.code === value.levelOfInterest;
                    });

                    if (!item) {
                        item = {
                            code: value.levelOfInterest,
                            items: []
                        };

                        activityData.push(item);
                    }

                    item.items.push(value);
                });

                _this11.activityReportData = activityData;
            });

            this.activityReportModal.show();
        }
    }, {
        key: 'exportActivity',
        value: function exportActivity() {
            this.sentEmailPopup.show(this.user.firstName + ' ' + this.user.name, this.emailReport.bind(this));
        }
    }, {
        key: 'emailReport',
        value: function emailReport() {
            var _this12 = this;

            this.$ionicLoading.show();
            this.ApiCampaigns.emailActivities(this.campaignId).then(function (_) {
                _this12.$ionicLoading.hide();
                _this12.MessageBox.showSuccessMessage('EXPORT_ACTIVITY_REPORT', 'SENT');
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.activityReportModal.hide();
        }
    }]);

    return CampaignDetailController;
}();

exports.default = CampaignDetailController;


/** WEBPACK FOOTER **
 ** ./src/app/components/campaigns/campaignDetail.controller.js
 **/